export default __webpack_public_path__ + "static/blue-in-page-be7aa0921c152595cb37f3794f4ee7ba.png";